import React, {Component} from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import Slider from '@material-ui/core/Slider';
import AgeSlider from './slider';
import CountryList from "./countrylist";
import HobbyList from "./hobbylist";
import ProfessionList from "./professionlist";
import Dropzone from "./dropzone";
import Datepicker from "./datepicker";
import { withRouter } from "react-router-dom";
import moment from 'moment';
import { loader } from '../../../actions/utils';
import { fetchCountryList, fetchCategoryList, fetchHobbyList } from "../../../actions/commonAction";
import { fetchPromotionType, fetchReach, savePreview, savePromotion, getPromotionLimit } from "../../../actions/promotionAction";
import { evcwalletPayment } from "../../../actions/evcAction";
import { cloudinaryMediaUploader } from './../../../helpers/cloudinaryFileUploader';
import  WalletConnection  from "./walletconnection";
import validateInput from "../../Validations/Promotion";

import {ToastsContainer, ToastsStore, ToastsContainerPosition} from 'react-toasts';
import Button from '@material-ui/core/Button';
import Snackbar from '@material-ui/core/Snackbar';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import { getlanguagelist } from "../../../helpers/changelanguage";
import $ from "jquery";


class PromotionCreate extends Component {
    constructor(props) {
      super(props);
      this.state = {
        headerData            : {},
        countryList           : null,
        categoryList          : null,
        hobbyList             : null,
        limitList             : null,
        display               : 'none',
        custom_display        : 'block',
        checked               : false,
        promotionType         : null,
        costSetup             : {},
        selection_range       : 1,
        promotion_days        : 1,
        is_editablecost       : true,
        base_cost             : 0,
        min_cost              : 0,
        max_cost              : 0,
        currency              : '',
        start_date            : new Date(),
        end_date              : new Date(Date.now() + ( 3600 * 1000 * 24)),
        perday_reach          : 0,
        total_reach           : 0,
        perday_spent          : 0,
        slider_percentage     : 0,
        promotion_description : '',
        promotion_heading     : '',
        start_age             : 13,
        end_age               : 65,
        gender                : 'ALL',
        age_range             : [13,65],
        hobby_range           : [],
        hobby_range_name      : [],
        hobby_range_json      : null,
        country_range         : null,
        country_range_name    : null,
        country_range_json    : null,
        profession_range      : [],
        profession_range_name : [],
        profession_range_json : null,
        image_list            : [],
        file_list             : [],
        media_files           : [],
        go_preview            : 0,
        budget_type           : '',
        payment_mode          : '',
        spinner               : '',
        error_validation      : '',
        snack                 : false,
        snackmessage          : '',
        modal                 : false,
        new_promotion_id      : 0,
    };
      this.onChange             = this.onChange.bind(this);
      this.changeSelection      = this.changeSelection.bind(this);
      this.calculatePricerange  = this.calculatePricerange.bind(this);
      this.onDateChange         = this.onDateChange.bind(this);
      this.onSliderChange       = this.onSliderChange.bind(this); 
      this.setGender            = this.setGender.bind(this);
      this.changeFile           = this.changeFile.bind(this);
      this.goPreview            = this.goPreview.bind(this);
      this.setFileList          = this.setFileList.bind(this);
      this.savePromotion        = this.savePromotion.bind(this);
      this.handleClosee         = this.handleClosee.bind(this);
      this.openModal            = this.openModal.bind(this);
      this.closeModal           = this.closeModal.bind(this);
      this.evcpayment           = this.evcpayment.bind(this);

    }
    componentDidMount() { 
        
        this.props.fetchCountryList();  
        this.props.fetchCategoryList('PROFESSION');  
        this.props.fetchHobbyList();  
        this.props.fetchPromotionType(); 
        this.props.getPromotionLimit(); 
    }
    UNSAFE_componentWillReceiveProps(nextProps){
        if((nextProps.countryList != null) || (this.state.is_country_change == 1)){
            this.setState({
                countryList   : nextProps.countryList,
                country_range : nextProps.countryList[0].country_code
            })
        }
        
        if((nextProps.promotionlimit != null) && (nextProps.promotionlimit != this.props.promotionlimit)){
            this.setState({
                limitList                  : nextProps.promotionlimit,
                selection_rangehobby_range : [nextProps.promotionlimit[0].id],
            })
        }
        if((nextProps.categoryList != null) && (nextProps.categoryList != this.props.categoryList)){
            this.setState({
                categoryList     : nextProps.categoryList,
                profession_range : [nextProps.categoryList[0].id],
            })
        }
        if((nextProps.hobbyList != null) && (nextProps.hobbyList != this.props.hobbyList)){
            this.setState({
                hobbyList   : nextProps.hobbyList,
                hobby_range : [nextProps.hobbyList[0].id],
            })
        }

        if((nextProps.promotionType != null) && (nextProps.promotionType != this.props.promotionType)){
            this.setState({
                promotionType : nextProps.promotionType,
                budget_type   : nextProps.promotionType.promotion_type.budget_type,
                promotion_days: 1,
                base_cost     : nextProps.promotionType.budget_list[0].min_cost,
                min_cost      : nextProps.promotionType.budget_list[0].min_cost,
                max_cost      : nextProps.promotionType.budget_list[0].max_cost, 
            },function(){
                this.calculatePricerange('1')
            })
            
        } 

        if(nextProps.calculateReach != this.props.calculateReach){
            this.setState({
                perday_reach        : parseInt(nextProps.calculateReach.per_day_reach),
                total_reach         : parseInt(nextProps.calculateReach.total_reach),
                slider_percentage   : Math.round((parseInt(nextProps.calculateReach.per_day_reach)/parseInt(nextProps.calculateReach.total_reach))*100),
                perday_spent        : nextProps.calculateReach.perday_amount_utilize,
                spinner             : ''
                
            },function(){
                if(this.state.go_preview == 1){
                    this.props.savePreview(this.state);
                    
                    this.props.history.push(`/promotion_preview`)
                }else if(this.state.go_preview == 2) {
                    this.savePromotion();
                }
                
            })  
        }

        if(nextProps.savepromotion != this.props.savepromotion){
            this.setState({
                new_promotion_id : nextProps.savepromotion.promotion_id
            },function(){

                if(this.state.budget_type == 'Free'){
                    this.props.history.push(`/promotion_list`)
                }else{
                    if(this.state.payment_mode == 'Cash'){
                        this.props.history.push(`/promotion_list`)
                    }else{
                        if(this.state.payment_mode == 'Online'){
                            window.location.href = nextProps.savepromotion.payment_url; 
                        }else{
                            this.openModal();
                        }
                    }
                   
                }
            })
            
        }
        if(nextProps.evc != this.props.evc){
            this.closeModal();
            let languagelist = getlanguagelist();
            if(Object.keys(nextProps.evc).length == 0){
                ToastsStore.error(languagelist.evcwalletfailure);
            }else{
                ToastsStore.success(languagelist.evcwalletsuccess);
            }
            this.props.history.push(`/promotion_list`)
        }
    }

    UNSAFE_componentWillUpdate(){
       /*  var scrollTop  = $(window).scrollTop(),
        elementOffset  = $('.content_block').offset().top,
        distance       = (elementOffset - scrollTop);
        if(distance > 0){
          $('.content_block').css('padding','0 0px 0px 55px');
        } */
    }
    
    onChange(e) {
        
        if(e === undefined){
            //this.calculateReach();
        }else{
            //console.log(e.target.value);
            this.setState({
                [e.target.name] : e.target.value,
            }, function(){
               // this.calculateReach();
            });
        }
    }
    onDateChange(type,date){
        if((date != 'Invalid Date') && (date != null)){
            if(type == 'startDate'){
           
                var tt = new Date(date);
                var newdate = new Date(tt);
                newdate.setDate(newdate.getDate() + 1);
                this.setState({
                    start_date : date,
                    end_date   : newdate
                }, function(){
                    //this.calculateReach();
                })
               
            }else{
                var g1 = this.state.start_date; 
                var g2 = date; 
                
                if(g1.getTime() < g2.getTime()){
                    var Difference_In_Time = g2.getTime() - g1.getTime(); 
                    var Difference_In_Days = Difference_In_Time / (1000 * 3600 * 24);
                    
                    let budget_list = this.state.promotionType.budget_list;
                    let matchedIndex = (budget_list).map(function (obj) { return obj.day; }).indexOf(Math.ceil(Difference_In_Days).toString());
                    
                    this.setState({
                        end_date        : date,
                        promotion_days  : Math.ceil(Difference_In_Days),
                        is_editablecost : ((Math.ceil(Difference_In_Days) == 1) && (this.state.promotionType.promotion_type.budget_type == 'Free')) ? true : false,
                        base_cost       : ((Math.ceil(Difference_In_Days) == 1) && (this.state.promotionType.promotion_type.budget_type == 'Free'))  ? 0 : budget_list[matchedIndex].min_cost,
                        min_cost        : budget_list[matchedIndex].min_cost,
                        max_cost        : budget_list[matchedIndex].max_cost,
                        budget_type     : ((Math.ceil(Difference_In_Days) == 1) && (this.state.promotionType.promotion_type.budget_type == 'Free'))  ? 'Free' : 'Paid',
                    }, function(){
                       // this.calculateReach();
                    })
                }
              
            }
        }else{
            this.setState({
                start_date : new Date(),
                end_date   : new Date(Date.now() + ( 3600 * 1000 * 24))
            })
        }
    }
    onSliderChange(range){
        this.setState({
            age_range : range
        }, function(){
            //this.calculateReach();
        })
    }
    calculateReach(state){
        this.setState({
            spinner : 'fa-spin'
        });
        if(state.checked == true)
        {   
            let reqParam = {
                chk_by_recent_reg       : 'Yes',
                rcnt_reg_filter_type    : state.selection_range,
                total_days              : state.promotion_days,
                min_budget              : state.min_cost,
                max_budget              : state.max_cost,
                total_budget            : state.base_cost,
                budget_type             : (state.promotion_days == 1) ? state.promotionType.promotion_type.budget_type : 'Paid',
            };
            this.props.fetchReach(reqParam);
        }else{
            let hobby_list = JSON.parse($("#hobby_range").val());
           
            let hobby_list_id = [];
            let hobby_list_name = [];
            hobby_list.map((row,index) => {
                hobby_list_id.push(row.id)
                hobby_list_name.push(row.category_name)
            })
           
            this.setState({
                hobby_range      : hobby_list_id,
                hobby_range_name : hobby_list_name,
                hobby_range_json : JSON.parse($("#hobby_range").val())
            })

            let country_list    = JSON.parse($("#country_range").val());
            let counter_c       = (country_list.length);
            
            let country_list_id   = '';
            let country_list_name = '';
            if(country_list.length > 0){
                country_list_id   = country_list[(counter_c - 1)].country_code;
                country_list_name = country_list[(counter_c - 1)].country_name;
            }
            this.setState({
                country_range      : country_list_id,
                country_range_name : country_list_name,
                country_range_json : JSON.parse($("#country_range").val())
            })
           
            let profession_list = JSON.parse($("#profession_range").val());
            let profession_list_id   = [];
            let profession_list_name = [];
            
            profession_list.map((row,index) => {
                //console.log(row.id);
                profession_list_id.push(row.id);
                profession_list_name.push(row.category_name);
            })
            this.setState({
                profession_range      : profession_list_id,
                profession_range_name : profession_list_name,
                profession_range_json : JSON.parse($("#profession_range").val())

            })
            
            let reqParam = {
                chk_by_recent_reg       : 'No',
                start_age               : state.age_range[0],
                end_age                 : state.age_range[1],
                profession              : JSON.stringify(profession_list_id),
                gender                  : state.gender,
                country                 : country_list_id,
                hobby                   : JSON.stringify(hobby_list_id),
                total_days              : state.promotion_days,
                min_budget              : state.min_cost,
                max_budget              : state.max_cost,
                total_budget            : state.base_cost,
                budget_type             : state.promotionType.promotion_type.budget_type,
            };
            this.props.fetchReach(reqParam);
        }
           
    }
    changeSelection(){
        this.setState({
            checked         : !this.state.checked,
            display         : (this.state.display == 'none') ? 'block' : 'none',
            custom_display  : (this.state.custom_display == 'none') ? 'block' : 'none'
        });
    }
    calculatePricerange(days){
        let budget_list = this.state.promotionType.budget_list;
        if(budget_list != null){
            let matchedIndex = (budget_list).map(function (obj) { return obj.day; }).indexOf(days);
            
            if(matchedIndex >= 0){
                this.setState({
                    base_cost       : (this.state.budget_type == 'Free') ? 0 : budget_list[matchedIndex].min_cost,
                    min_cost        : budget_list[matchedIndex].min_cost,
                    max_cost        : budget_list[matchedIndex].max_cost,
                    currency        : budget_list[matchedIndex].currency,
                    is_editablecost : (this.state.budget_type == 'Free') ? true : false,
                })
            }
        } 
    }
    setGender(value){
        this.setState({
            gender :  value
        });
    }
    changeFile(){
        const { error, isValid } = validateInput(this.state);
       
        if (isValid) {
            if(this.state.file_list.length > 0){
                let new_res = [];
                let uploadResponse = [];
                loader(true);
                uploadResponse = cloudinaryMediaUploader(this.state.file_list);
                uploadResponse.then((response)=>{
                    response.map(res => {
                    new_res.push({'media_type':res.data.resource_type,'media_link':`${res.data.public_id}.${res.data.format}`});
                    })
                    this.setState({
                    media_files: new_res,
                    go_preview : 2
                    },function(){
                        
                        this.calculateReach(this.state);    
                    
                        // this.savePromotion();
                    });
                });
            }else{
                this.setState({
                    go_preview : 2
                },function(){
                        
                    this.calculateReach(this.state);    
                    
                        // this.savePromotion();
                });
                //this.savePromotion();
            }
        }else{
            this.setState({
                snack        : true,
                snackmessage : error.message
            })
        } 
    }
    goPreview(){
        const { error, isValid } = validateInput(this.state);
        if (isValid) {
            if(this.state.profession_range_name.length == 0){
                this.setState({
                    go_preview : 1
                },function(){
                    this.calculateReach(this.state);    
                })
            }else{
                this.props.savePreview(this.state);
                this.props.history.push(`/promotion_preview`)
            }
        }else{
            this.setState({
                snack        : true,
                snackmessage : error.message
            })
        } 
    }
    savePromotion(){
       
        let country_list    = JSON.parse($("#country_range").val());
        let counter_c       = (country_list.length);
        let country_list_id = '';
        if(country_list.length > 0){
            country_list_id = country_list[(counter_c - 1)].country_code;
        }
       
       
            let param = {
                chk_by_recent_reg     : (this.state.checked == true) ? 'Yes' : 'No',
                rcnt_reg_filter_type  : this.state.selection_range,  
                start_age             : this.state.age_range[0],
                end_age               : this.state.age_range[1],
                profession            : (this.state.checked == true) ? JSON.stringify([]) : JSON.stringify(this.state.profession_range),
                gender                : (this.state.checked == true) ? 'ALL' : this.state.gender,
                country               : (this.state.checked == true) ? '' : country_list_id,
                hobby                 : (this.state.checked == true) ? JSON.stringify([]) : JSON.stringify(this.state.hobby_range),
                start_date            : (moment(this.state.start_date).format('YYYY-MM-DD')),//this.state.start_date,
                end_date              : (moment(this.state.end_date).format('YYYY-MM-DD')),//this.state.end_date,
                total_days            : this.state.promotion_days,
                min_budget            : this.state.min_cost,
                max_budget            : this.state.max_cost,
                total_budget          : this.state.base_cost,
                budget_type           : this.state.budget_type,
                promotion_type        : 'CUSTOM',
                promotion_name        : this.state.promotion_heading,
                promotion_description : this.state.promotion_description,
                promotion_pic         : JSON.stringify(this.state.media_files),
                payment_mode          : (this.state.budget_type == 'Free') ? null : this.state.payment_mode
            }
            this.props.savePromotion(param);
        
       
    }
    handleClosee(){ 
        this.setState({
            snack : false
        });
    }
    setFileList(fileList){
        this.setState({
            file_list : fileList
        })
    }
    openModal(){
        this.setState({
            modal : true
        })
    }
    closeModal(){
        this.setState({
            modal : false
        })
    }
    evcpayment(phone){

        let param = {
            reference_id     : this.state.new_promotion_id,
            payment_reason   : 'PROMOTION',
            phone_no         : `252${phone}`
        }
        this.props.evcwalletPayment(param);  
    }
    
    render() {
        let languagelist = getlanguagelist();
        let limit = this.state.limitList || [];
        return (
            <div className="content_area">
                <div className="col-lg-12">
                    <h3 className="heading_2">{languagelist.createpromotion}:</h3>
                </div>
                <div className="clr10"></div>

                <div className="col-xs-12 col-sm-6 col-md-3 col-lg-3 left_area">
                    <div className="left_fixt">
                        <div className="known">
                            <h3>{languagelist.promotiondes} <i className="fa fa-asterisk mandatory-field" aria-hidden="true"></i></h3>
                            <div className="description_box">
                                <textarea className="description_fild" name="promotion_description" placeholder={languagelist.typepromotiondes} defaultValue={this.state.promotion_description}  onChange={this.onChange}></textarea>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col-xs-12 col-sm-12 col-md-6 col-lg-9 post_area">
                    <div className="row">
                        <div className="post_box known image-sec">

                            <div className="clr20"></div>

                            <div className="col-lg-12">
                                <div className="infi_fild">
                                    <img className="pull-left" src="/assets/images/commend_circle.png" />
                                    <div className="input_mid pull-left">
                                        <label>{languagelist.promotionhead} <i className="fa fa-asterisk mandatory-field" aria-hidden="true"></i></label> 
                                        <div className="clr10"></div>
                                        <input type="text" placeholder={languagelist.typepromotionhead} name="promotion_heading" value={this.state.promotion_heading} onChange={this.onChange} style={{width :'400px'}}  />
                                    </div>
                                    <div className="clearfix"></div>
                                </div>
                                <div className="clr10"></div>
                                <Dropzone setFileList={this.setFileList} userId={this.props.currentUserDetails.user.id}/>
                            </div>
                            <div className="clr20"></div>
                        </div>
                        <div className="post_box pad_15">
                        <label className="c_chackbox">{languagelist.selection}
                            <input type="checkbox"  defaultChecked={this.state.checked} onChange={this.changeSelection}/>
                            <span className="checkmark"></span>
                        </label>

                        <div className="col-lg-3 checkbox-promotion" style={{display:this.state.display}} >
                            <select className="form-control" name="selection_range"  value={this.state.selection_range} onChange={this.onChange}>
                                {
                                    limit.map((limit,index) => {
                                        return ( <option value={limit.id} key={`limit_${index}`}>{limit.category_name}</option>
                                                )
                                    })
                                }
                            </select>
                        </div>
                    </div>
                    </div>
                </div>
                <div className="col-lg-12">
                    <div className="row">
                        <div className="col-lg-3" style={{display:this.state.custom_display}}>
                            
                            <div className="post_box known">
                                <div className="post_box_padd_slider">
                                    <div className="text-center">
                                        
                                        <img src="/assets/images/age_group_icon.png" />
                                        <h4>{languagelist.agegrp}</h4>
                                        <div className="clr20"></div>
                                        <div className="row">
                                            <div className="col-lg-2"> {this.state.age_range[0]}</div> 
                                            <div className="col-lg-8"> <AgeSlider start_age={this.state.start_age} end_age={this.state.end_age} onSliderChange={this.onSliderChange} onChange={this.onChange}/></div> 
                                            <div className="col-lg-2"> {this.state.age_range[1]}</div> 

                                        </div>
                                       {/*  <input type="range" min="1" max="100" value="50" onChange={this.onChange}/> */}
                                      {/* <AgeSlider start_age={this.state.start_age} end_age={this.state.end_age} onSliderChange={this.onSliderChange} onChange={this.onChange}/>*/}
                                    </div>
                                </div>
                            </div>
                           
                        </div>

                        <div className="col-lg-3" style={{display:this.state.custom_display}}>
                             <div className="row">
                            <div className="post_box known">
                                <div className="post_box_padd_slider">
                                    <div className="text-center">
                                        <img src="/assets/images/hobby_icon.png" />
                                        <h4>{languagelist.promotionprof}</h4>
                                        
                                        <div className="clr20"></div>
                                        {
                                            (this.state.categoryList != null)  ? 
                                            <ProfessionList categoryList={this.state.categoryList} onChange={this.onChange}/> 
                                            : null
                                        }

                                    </div>

                                </div>
                            </div>
                            </div>
                        </div>
                        <div className="col-lg-3" style={{display:this.state.custom_display}}>
                            <div className="post_box known">
                                <div className="post_box_padd">
                                    <div className="text-center">
                                        <img src="/assets/images/gesder_icon.png" />
                                        <h4>{languagelist.gender}</h4>
                                        
                                        <div className="clr20"></div>

                                        <div className="gendar_list">
                                            <a className={(this.state.gender == 'ALL') ? 'active' : ''} href={void(0)} onClick={()=>this.setGender('ALL')}>{languagelist.all}</a>
                                            <a className={(this.state.gender == 'M') ? 'active' : ''} href={void(0)} onClick={()=>this.setGender('M')}>{languagelist.men}</a>
                                            <a className={(this.state.gender == 'F') ? 'active' : ''} href={void(0)} onClick={()=>this.setGender('F')}>{languagelist.women}</a>
                                            <a className={(this.state.gender == 'T') ? 'active' : ''} href={void(0)} onClick={()=>this.setGender('T')}>{languagelist.otherg}</a>
                                        </div>

                                    </div>

                                </div>
                            </div>
                        </div>

                        <div className="col-lg-3" style={{display:this.state.custom_display}}>
                        <div className="row">
                            <div className="post_box known">
                                <div className="post_box_padd_slider">
                                    <div className="text-center">
                                         <img src="/assets/images/cuntry_icon.png" />
                                        <h4>{languagelist.country}</h4>
                                        
                                        <div className="clr20"></div>

                                        {
                                            (this.state.countryList != null)  ? 
                                            <CountryList countryList={this.state.countryList} onChange={this.onChange}/>
                                            : null
                                        }
                                    </div>

                                </div>
                            </div>
                        </div>
                        </div>
                    </div>

                    <div className={(this.state.custom_display == 'none') ? "row  div-bottom" : "row"}>
                        <div className="col-lg-3" style={{display:this.state.custom_display}}>
                            <div className="post_box known">
                                <div className="post_box_padd_slider">
                                    <div className="text-center">
                                        <img src="/assets/images/hobby_icon.png" />
                                        <h4>{languagelist.hobbies}</h4>
                                        
                                        <div className="clr20"></div>

                                        {
                                            (this.state.hobbyList != null)  ? 
                                            <HobbyList hobbyList={this.state.hobbyList} onChange={this.onChange} />
                                            : null
                                        }

                                    </div>

                                </div>
                            </div>
                        </div>
                        <div className={(this.state.custom_display == 'none') ? "col-lg-12" : "col-lg-9"}>
                           <div className="row">
                            <div className="post_box known">
                                <div className="post_box_padd">
                                    <div className="text-center">
                                       
                                        <img src="/assets/images/calendar_icon.png" />
                                        <h4>{languagelist.durabudget}</h4>
                                        <div className="clr20"></div>
                                    </div>
                                    <div className="col-lg-6" style={{paddingRight :'40px'}}>
                                        <div className="row">
                                            <div className="col-lg-6">
                                                <span>{languagelist.fdate}</span>
                                                <Datepicker defaultDate={this.state.start_date} onDateChange={this.onDateChange} type="startDate"/>
                                            </div>
                                            <div className="col-lg-6">
                                                <span>{languagelist.tdate}</span>
                                                <Datepicker defaultDate={this.state.end_date} onDateChange={this.onDateChange} type="endDate"/>
                                            </div>
                                            <div className="col-lg-12">
                                                <div className="clr10"></div>
                                                <span>{languagelist.budgetdesc}</span>
                                            </div>

                                            <div className="col-lg-6">
                                                <a href="#" className="line_box line_box_active_2 btn-block">{this.state.promotion_days} {languagelist.days}</a>
                                            </div>
                                            <div className="col-lg-6">
                                            
                                             <p className="price_sim">$</p>
                                             <input 
                                                className="line_box line_box_active price_input" 
                                                type="number" 
                                                name="base_cost" 
                                                value={this.state.base_cost} 
                                                step="1.00" 
                                                min={this.state.min_cost} 
                                                max={this.state.max_cost} 
                                                onChange={this.onChange} 
                                                readOnly={this.state.is_editablecost}
                                              />
                                              <div className="clearfix"></div>
                                              <span className="cost-limit"> {languagelist.costlimit} {this.state.min_cost} {languagelist.to} {this.state.max_cost}</span>
                                            </div>
                                        </div>

                                    </div>
                                    <div className="col-lg-6 with_sep">
                                        
                                        <h5>{languagelist.peoplereach}                                          
                                        </h5>
                                        
                                        <div className="row">
                                            <div className="col-lg-10">{languagelist.approxreach} {this.state.perday_reach} {languagelist.peopleperday} </div>
                                            <div className="col-lg-2"><span className="pull-right">{languagelist.of} {this.state.total_reach}</span></div>
                                        </div>
                                        <div className="progress">
                                            <div className="progress-bar" role="progressbar" aria-valuenow={this.state.slider_percentage} aria-valuemin="0" aria-valuemax="100" style={{width:`${this.state.slider_percentage}%`}}>
                                                
                                            </div>
                                        </div>
                                        
                                        <span>{languagelist.spend} <strong>${this.state.perday_spent}</strong> {languagelist.perday}. {languagelist.adrunfor} {this.state.promotion_days} {languagelist.days}, {languagelist.endingon} {(moment(this.state.end_date).format('DD/MM/YYYY'))}.
                                        </span>
                                       <div className="row">
                                           {(this.state.budget_type != 'Free') ?
                                            <div className="col-lg-6"> 
                                                <select className="form-control" name="payment_mode" value={this.state.payment_mode} onChange={this.onChange}>   
                                                <option value='' >{languagelist.paymentmode} </option>
                                               {/*  <option value='Cash' >{languagelist.cash}</option> */}
                                                <option value='Online' >{languagelist.payoptn2}</option>
                                                <option value='EVC_wallet' >{languagelist.payoptn1}</option>
                                                </select>
                                            </div>
                                           : null }

                                            <div className="col-lg-6" className="pull-right"> 
                                                <span className="pull-right">
                                                    <button className="btn_3" onClick={()=>this.calculateReach(this.state)}>
                                                        <i className={`fa fa-spinner ${this.state.spinner}`}></i> {languagelist.calculatereach}
                                                    </button>
                                                </span>
                                            </div>
                                        </div>

                                    </div>

                                </div>
                                <div className="clr20"></div>
                            </div>
                           </div>
                        </div>
                        <div className="clr20" />
                        <div className="text-center promotion_btn" >
                         <div className="col-lg-3" style={{display:this.state.custom_display}}>&nbsp;</div>
                         <div className={(this.state.custom_display == 'none') ? "col-lg-12" : "col-lg-9"} >
                            <a href={void(0)} className="btn_5" onClick={this.goPreview}>{languagelist.preview}</a> &nbsp;
                            <a href={void(0)} className="btn_5" onClick={this.changeFile}>{languagelist.createpay}</a> 
                         </div>
                           
                        </div>
                    </div>

                   <WalletConnection modalOpen={this.state.modal} closeModal={this.closeModal} evcpayment={this.evcpayment}/>         
                </div>
                <Snackbar
                    anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'left',
                    }}
                    open={this.state.snack}
                    autoHideDuration={6000}
                    message={this.state.snackmessage}
                    action={
                        <React.Fragment>
                          <Button color="secondary" size="small" onClick={this.handleClosee}>
                          {languagelist.undo}
                            </Button>
                             <IconButton size="small" aria-label="close" color="inherit" onClick={this.handleClosee}>
                            <CloseIcon fontSize="small" />
                          </IconButton>
                        </React.Fragment>
                      }
                    
                />
            </div>   

           
        );
  }
}
const mapStateToProps = state => {
  
  return {
    countryList        : state.countrylist.countryList,
    categoryList       : state.categorylist.categoryList,
    promotionType      : state.promotiontype.promotionType,
    calculateReach     : state.calculatereach.calculateReach,
    hobbyList          : state.hobbylist.hobbyList,
    savepromotion      : state.savepromotion.paymentUrl,
    currentUserDetails : state.login, 
    promotionlimit     : state.promotionlimit.promotionLimit,
    evc                : state.wallet.walletReply
  }
}
const mapDispatchToProps = dispatch => {
  return {
    fetchCountryList            : bindActionCreators(fetchCountryList, dispatch),
    fetchCategoryList           : bindActionCreators(fetchCategoryList, dispatch),
    fetchHobbyList              : bindActionCreators(fetchHobbyList, dispatch),
    fetchPromotionType          : bindActionCreators(fetchPromotionType, dispatch),
    fetchReach                  : bindActionCreators(fetchReach, dispatch),
    savePreview                 : bindActionCreators(savePreview, dispatch),
    savePromotion               : bindActionCreators(savePromotion, dispatch),
    getPromotionLimit           : bindActionCreators(getPromotionLimit, dispatch),
    evcwalletPayment            : bindActionCreators(evcwalletPayment, dispatch),
  }
}
export default withRouter(connect(
  mapStateToProps,
  mapDispatchToProps
)(PromotionCreate));